import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import strings from '../../components/locales/';
import { Tooltip } from 'react-bootstrap';

/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as loginActions from '../../actions/login/index';
import * as dashboardActions from '../../actions/dashboard/index';
import * as headerActions from '../../actions/header/index';
import * as surveyActions from '../../actions/survey/index';

/*locale*/
import String from '../../components/locales';

class Expired extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleLogOut = async () => {
    let lang = localStoreFN().getItem('lang');
    this.props.dashboardActions.resetDashboard();
    this.props.surveyActions.resetSurvey();
    this.props.headerActions.resetHeader();
    await this.props.actionsLogin.logOut();
    if(lang) {
      this.props.history.push('/lang/'+lang);
    }
    else {
      this.props.history.push('/');
    }
  };


  componentDidMount() {    
    if (this.props.loadingLanguage == true) {
      let lang = localStoreFN().getItem('lang');
      if(lang) {
        String.setLanguage(lang);
        this.props.dashboardActions.handleLanguageChange(String);
      }
    }
  }

  render() {
    return (
      <div data-close="ok" onClick={this.handleLogOut} className="container-modal">
        <div className={`box-modal max500`}>
          <a>
            <i data-close="ok" onClick={this.handleLogOut} className="fas fa-times-circle" />
          </a>
          <section className="module-title">
            <h2>{this.props.languageReducer ? this.props.languageReducer.login.main.sessionExpiredTitle : ''}</h2>
          </section>
          <section className={'feed-back gris'}>
            <div>
              <i className="fal fa-clock gris-icon" />
            </div>
            <div>
              <p>{this.props.languageReducer ? this.props.languageReducer.login.main.sessionExpired : ''}</p>
            </div>
          </section>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  languageReducer: state.reducer.dashboard.language,
  loadingLanguage: state.reducer.dashboard.loadingLanguage
});
const mapDispatchToProps = dispatch => ({
  actionsLogin: bindActionCreators(loginActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch),
  headerActions: bindActionCreators(headerActions, dispatch),
  surveyActions: bindActionCreators(surveyActions, dispatch)
});
Expired.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Expired);



// WEBPACK FOOTER //
// ./source/client/containers/expired/index.jsx